import { createContext } from "react";

interface PageContextInterface {
  headerStyle: string;
  isHeaderFixed: boolean;
  pageType: string;
}

const PageContext = createContext<PageContextInterface | undefined>(undefined);

export default PageContext;
